import "./InstrumentUI.css"
import React from "react"
import {InstrumentTableRow} from "../../../../data/services/instrument-table-service";
import {ReactComponent as RevioIcon} from "../../assets/icn_revio.svg";
import {ReactComponent as VegaIcon} from "../../assets/icn_vega.svg";
import {StatusPlot} from "../statusplot/StatusPlot";

export interface InstrumentProps {
    row: InstrumentTableRow;
    clicked: (id: InstrumentTableRow) => void;
    isSelected?: boolean;
    isHovered?: boolean;
    isSelectedAndHovered?: boolean;
}

const InstrumentUI = ({row, clicked, isSelected, isHovered, isSelectedAndHovered}: InstrumentProps) => {
    const className = [
        "instrument",
        isSelected ? "instrument-selected" : "",
        isHovered ? "instrument-hovered" : "",
        isSelectedAndHovered ? "instrument-selected-hovered" : ""
    ].join(" ");

    const handleClick = () => {
        clicked(row);
    };

    let statecolor: string;
    switch (row.state) {
        case "Ready":
            statecolor = "var(--green-bright-color)"
            break;
        case "Running":
            statecolor = "var(--blue-medium-color)"
            break;
        case "Problem":
            statecolor = "var(--gray-light-color)"
            break;
    }

    let Icon: React.ComponentType<React.SVGProps<SVGSVGElement>> | null;
    switch (row.instrumentType) {
        case "Revio":
            Icon = RevioIcon;
            break;
        case "Vega":
            Icon = VegaIcon;
            break;
        default:
            Icon = null;
    }

    return (
        <div className={className} onClick={handleClick}>
            <div className="instrument-icon">
                {Icon &&
                    <Icon style={{width: "24px", height: "auto", verticalAlign: "bottom", marginTop: "6px", color: statecolor}}/>
                }
                {row.alarmMessage &&
                    <div className="instrument-alarm-icon">!</div>
                }
            </div>
             <div className="instrument-data">
                <div className="instrument-data-namestate">
                    <div className="instrument-name">
                        {row.name}
                    </div>
                    <div className="instrument-typestate">
                        <div className="instrument-type-text">
                            {row.instrumentType}
                        </div>
                        <div className="instrument-state-text" style={{color: statecolor}}>
                            {row.state}
                        </div>
                    </div>
                </div>
                <div className="instrument-cellplot">
                    <StatusPlot runInfos={row.runInfos} style={{border: "1px solid var(--pale-gray)"}}/>
                </div>
            </div>
        </div>
    );
}

export default InstrumentUI;
